import { AutogenLayoutZoneArea } from "./autogen/AutogenLayoutZoneArea";
import { DuplicateId, DuplicateIdProps } from "./DuplicateId";

export class ZoneArea extends AutogenLayoutZoneArea {

    override onLoad(): void | Promise<void> {
        this.validateZoneAreaRecordExist();
    }

    private validateZoneAreaRecordExist() {
        const zoneAreaUrl = "lme/dispatch/ZoneArea?mode=update&key=";
        const validateProps: DuplicateIdProps = { tableName: "zone_area", screenName: "ZoneArea", navigateToUrl: zoneAreaUrl };
        DuplicateId.configureIdTextbox(this.textboxId, validateProps);
    }

}
